export interface ShouldIndexMeta {
  googlebot?: boolean;
  yandex?: boolean;
  bingbot?: boolean
}

export function addNoindexMeta(meta: Array<object>, shouldIndex: boolean|ShouldIndexMeta): void {

  if (typeof shouldIndex === "boolean") {
    if (!shouldIndex) {
      meta.push({ name: "robots", content: "noindex" });
    }
  } else {
    if ('googlebot' in shouldIndex && shouldIndex.googlebot === false) {
      meta.push({ name: "googlebot", content: "noindex" });
    }
    if ('yandex' in shouldIndex && shouldIndex.yandex === false) {
      meta.push({ name: "yandex", content: "noindex" });
    }
    if ('bingbot' in shouldIndex && shouldIndex.bingbot === false) {
      meta.push({ name: "bingbot", content: "noindex" });
    }
  }
}